/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */

/**
 * App requests token from server
 */
export const TOKEN_REQUEST = 'TOKEN_REQUEST';

/**
 * App receives token from server in response to token request
 */
export const TOKEN_RESPONSE = 'TOKEN_RESPONSE';

/**
 * Destroy the token
 */
export const TOKEN_DESTROY = 'DESTROY_TOKEN';

/**
 * App requests coordinates for site map marker from google geocoding api
 */
export const GEOCODE_REQUEST = 'GEOCODE_REQUEST';
/**
 * App receives response to a request for coordinates for sit map marker from google geocoding api
 */
export const GEOCODE_RESPONSE = 'GEOCODE_RESPONSE';

/**
 * User requested to step back in a wizard form.
 */
export const REVERSE_WIZARD_FORM = 'REVERSE_WIZARD_FORM';

/**
 * User requested to move forward in a wizard form.
 */
export const PROCEED_WIZARD_FORM = 'PROCEED_WIZARD_FORM';

/**
 * User requested final submission of wizard form.
 */
export const SUBMITTING_WIZARD_FORM = 'SUBMITTING_WIZARD_FORM';

/**
 * Submission of wizard form.
 */
export const SUBMIT_WIZARD_FORM = 'SUBMIT_WIZARD_FORM';

/**
 * Initialization of wizard form data.
 */
export const INITIALIZE_WIZARD_FORM = 'INITIALIZE_WIZARD_FORM';

/**
 * Reset the wizard from to the page view and submission status.
 */
export const RESET_WIZARD_FORM = 'RESET_WIZARD_FORM';

/**
 * App requests that a model be created
 */
export const CREATE_MODEL_REQUEST = 'CREATE_MODEL_REQUEST';

/**
 * App receives response for request for a model to be created
 */
export const CREATE_MODEL_RESPONSE = 'CREATE_MODEL_RESPONSE';

/**
 * App requests that a run be created
 */
export const CREATE_RUN_REQUEST = 'CREATE_RUN_REQUEST';

/**
 * App receives response for request for a run to be created
 */
export const CREATE_RUN_RESPONSE = 'CREATE_RUN_RESPONSE';

/**
 * App requests a model
 */
export const FETCH_MODEL_REQUEST = 'FETCH_MODEL_REQUEST';

/**
 * App receives response for request for a model
 */
export const FETCH_MODEL_RESPONSE = 'FETCH_MODEL_RESPONSE';

/**
 * App requests models for the current user's org
 */
export const FETCH_MODELS_REQUEST = 'FETCH_MODELS_REQUEST';

/**
 * App receives response for request for models for the current user's org
 */
export const FETCH_MODELS_RESPONSE = 'FETCH_MODELS_RESPONSE';

/**
 * App sets id for the current model
 */
export const SET_CURRENT_MODEL = 'SET_CURRENT_MODEL';

/**
 * App requests that a model be created
 */
export const UPDATE_MODEL_REQUEST = 'UPDATE_MODEL_REQUEST';

/**
 * App receives response for request for a model to be created
 */
export const UPDATE_MODEL_RESPONSE = 'UPDATE_MODEL_RESPONSE';


/**
 * App requests a url for downloading a report
 */
export const FETCH_REPORT_URL_REQUEST = 'FETCH_REPORT_URL_REQUEST';

/**
 * App receives response for request for report url
 */
export const FETCH_REPORT_URL_RESPONSE = 'FETCH_REPORT_URL_RESPONSE';

/**
 * App requests a blob for a report
 */
export const FETCH_REPORT_BLOB_REQUEST = 'FETCH_REPORT_BLOB_REQUEST';

/**
 * App receives response for request for report blob
 */
export const FETCH_REPORT_BLOB_RESPONSE = 'FETCH_REPORT_BLOB_RESPONSE';

/**
 *
 * Value in redux form field changes
 */
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';

/**
 *
 * Redux form field initialize
 */
export const REDUX_FORM_INITIALIZE = '@@redux-form/INITIALIZE';

/**
 * Set visibility of redux form field
 */
export const SET_FIELD_VISIBILITY = 'SET_FIELD_VISIBILITY';



// WEBPACK FOOTER //
// ./js/constants/actionTypes.js